import { Column } from 'react-table';

import { IOverallProjectUsageTableData } from './OverallTranslateTableView.interfaces';


const OVERALL_TEXT_SPEECH_TABLE_COLUMNS: ReadonlyArray<Column<IOverallProjectUsageTableData>> = [
  {
    accessor: 'action',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Feature</div>,
  },
  {
    accessor: 'date',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Date</div>,
  },
  {
    accessor: 'apiKeyTitle',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>API key</div>,
  },
  {
    accessor: 'characters',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Total characters</div>,
  },
];

export { OVERALL_TEXT_SPEECH_TABLE_COLUMNS };
